export const generaneUuid = () => {
  const crypto = window.crypto || window.msCrypto
  const array = new Uint32Array(1)
  return Math.ceil(crypto.getRandomValues(array) * 9999)
}
